import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { DragSource } from 'react-dnd'
import ItemTypes from '../constants/ItemTypes'

const style = {
	cursor: 'move'
}

class Box extends Component {
	render() {
		const { hideSourceOnDrag, left, top, connectDragSource, isDragging, children } = this.props
		if (isDragging && hideSourceOnDrag) {
			return null
		}

		return connectDragSource(
			<div style={ { ...style, left, top } }>
				{ children }
			</div>
		)
	}
}

Box.propTypes = {
	connectDragSource: PropTypes.func.isRequired,
	isDragging: PropTypes.bool.isRequired,
	id: PropTypes.any.isRequired,
	left: PropTypes.number.isRequired,
	top: PropTypes.number.isRequired,
	hideSourceOnDrag: PropTypes.bool.isRequired,
	children: PropTypes.node,
	onDrag: PropTypes.func.isRequired
}

const boxSource = {
	beginDrag(props) {
		const { id, left, top, children } = props
		return {
			boxes: [
				{ id, left, top, children }
			]
		}
	},
	endDrag(props) {
		props.onDrag(props.id)
	}
}

const collect = (connect, monitor) => {
	return {
		connectDragSource: connect.dragSource(),
		isDragging: monitor.isDragging()
	}
}

export default DragSource(ItemTypes.BOX, boxSource, collect)(Box)



// WEBPACK FOOTER //
// ./src/components/drag/components/Box.js